// Default element definitions for the offer-page builder.
//
// Extracted from OfferPageBuilderSimple.js. Each key is an ELEMENT_TYPES
// value; the value is the default style/content shape used when a new
// element of that type is inserted into the editor.
//
// NOTE: source indentation is preserved verbatim because some entries
// contain template literals (CSS gradients, etc.) whose interior whitespace
// is part of the emitted styles.

import { ELEMENT_TYPES, LAYOUT_TYPES } from './offerElementTypes';

export const DEFAULT_ELEMENTS = {
  [ELEMENT_TYPES.HEADING]: {
    type: ELEMENT_TYPES.HEADING,
    content: 'Headline 1',
    styles: {
      fontSize: '28px',
      fontWeight: 'bold',
      color: '#333333',
      textAlign: 'center',
      marginBottom: '2px'
    }
  },
  [ELEMENT_TYPES.TEXT]: {
    type: ELEMENT_TYPES.TEXT,
    content: 'Add your compelling offer description here. Explain the benefits and value proposition that makes this offer irresistible.',
    styles: {
      fontSize: '16px',
      color: '#666666',
      lineHeight: '1.6',
      marginBottom: '8px'
    }
  },
  [ELEMENT_TYPES.IMAGE]: {
    type: ELEMENT_TYPES.IMAGE,
    content: 'https://via.placeholder.com/400x200?text=Product+Image',
    alt: 'Product Image',
    styles: {
      width: '100%',
      maxWidth: '400px',
      height: 'auto',
      marginBottom: '8px',
      textAlign: 'center'
    }
  },
  [ELEMENT_TYPES.CROPPABLE_IMAGE]: {
    type: ELEMENT_TYPES.CROPPABLE_IMAGE,
    imageSrc: '',
    croppedImage: '',
    crop: { x: 0, y: 0 },
    zoom: 1,
    croppedAreaPixels: null,
    styles: {
      width: 300,
      height: 200,
      backgroundColor: '#e0e0e0',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      overflow: 'hidden',
      position: 'relative',
      borderRadius: '8px',
      maintainAspectRatio: true
    },
  },
  [ELEMENT_TYPES.CIRCULAR_IMAGE]: {
    type: ELEMENT_TYPES.CIRCULAR_IMAGE,
    imageSrc: '',
    croppedImage: '',
    crop: { x: 0, y: 0 },
    zoom: 1,
    croppedAreaPixels: null,
    styles: {
      width: 200,
      height: 200,
      borderRadius: '50%',
      backgroundColor: '#e0e0e0',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      overflow: 'hidden',
      position: 'relative',
    },
  },
  [ELEMENT_TYPES.FITTABLE_IMAGE]: {
    type: ELEMENT_TYPES.FITTABLE_IMAGE,
    imageSrc: '',
    imagePosition: { x: 0, y: 0 },
    imageScale: 1,
    styles: {
      width: '100%',
      height: 300,
      backgroundColor: '#f9f9f9',
      border: '2px dashed #ccc',
      borderRadius: '8px',
      overflow: 'hidden',
      position: 'relative',
    },
  },
  [ELEMENT_TYPES.BUTTON]: {
    type: ELEMENT_TYPES.BUTTON,
    content: 'Get This Offer Now!',
    url: '#',
    styles: {
      backgroundColor: '#ff6b35',
      color: '#ffffff',
      padding: '15px 30px',
      fontSize: '18px',
      fontWeight: 400,
      border: 'none',
      borderRadius: '5px',
      textDecoration: 'none',
      display: 'inline-block',
      width: '100%',
      marginBottom: '8px',
      textAlign: 'center'
    }
  },
  [ELEMENT_TYPES.VIDEO]: {
    type: ELEMENT_TYPES.VIDEO,
    content: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    videoFile: '',
    thumbnailUrl: '',
    styles: {
      width: '100%',
      height: '315px',
      marginBottom: '0px'
    }
  },
  [ELEMENT_TYPES.VIDEO_WITH_BUTTON_OVERLAY]: {
    type: ELEMENT_TYPES.VIDEO_WITH_BUTTON_OVERLAY,
    content: 'Get Started Now',
    url: '#',
    videoFile: '',
    thumbnailUrl: '',
    styles: {
      backgroundColor: '#1976d2',
      color: '#ffffff',
      padding: '12px 24px',
      borderRadius: '8px',
      fontWeight: 'bold',
      fontSize: '16px',
      width: '100%',
      border: 'none',
      boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
      textAlign: 'center'
    }
  },
  [ELEMENT_TYPES.MEDIA]: {
    type: ELEMENT_TYPES.MEDIA,
    mediaUrl: '',
    thumbnailUrl: '',
    styles: {
      width: '100%',
      maxWidth: '100%',
      height: 'auto',
      marginBottom: '0px'
    }
  },
  [ELEMENT_TYPES.HTML]: {
    type: ELEMENT_TYPES.HTML,
    content: '<div style="text-align: center; padding: 20px; background: #f5f5f5; border-radius: 8px;">🎉 Custom HTML Content - Add any code here! 🎉</div>',
    styles: {
      marginBottom: '0px'
    }
  },
  [ELEMENT_TYPES.DIVIDER]: {
    type: ELEMENT_TYPES.DIVIDER,
    styles: {
      height: '1px',
      backgroundColor: '#e0e0e0',
      margin: '0px 0',
      border: 'none'
    }
  },
  [ELEMENT_TYPES.LAYOUT]: {
    type: ELEMENT_TYPES.LAYOUT,
    layoutType: LAYOUT_TYPES.SINGLE,
    zones: [{ id: 'zone-1', elements: [] }],
    styles: {
      marginBottom: '0px',
      padding: '4px',
      border: '2px dashed #e0e0e0',
      borderRadius: '8px'
    }
  },
  [ELEMENT_TYPES.CHECKLIST]: {
    type: ELEMENT_TYPES.CHECKLIST,
    title: "Why FluffCo Gets Oprah's Seal of Approval",
    items: [
      { icon: 'verified', text: 'The Deepest Sleep\nWake up refreshed each morning.' },
      { icon: 'verified', text: 'Tailored Comfort\nPerfectly cradles your neck and head.' },
      { icon: 'verified', text: 'Cool and Dry\nBreathable cotton for a cool, moisture-free sleep.' },
      { icon: 'verified', text: 'Allergy-Free\nHypoallergenic filling protects against allergies.' },
      { icon: 'verified', text: 'The Highest Quality\n300 thread count with durable, double-edge seams.' },
      { icon: 'verified', text: 'Machine-Washable\nFast and easy to clean and maintain.' },
    ],
    styles: { marginBottom: '10px' }
  },
  [ELEMENT_TYPES.BUTTON_WITH_NOTICE]: {
    type: ELEMENT_TYPES.BUTTON_WITH_NOTICE,
    variant: 'urgent-sale',
    styleVariant: 'default',
    content: {
      notice: 'UPDATE June 11, 2025: You can access the 70% OFF SALE by clicking this exclusive link below. Due to HIGH DEMAND, stock is currently reduced in several regions, and the sale is ending very soon.',
      callToAction: 'Don\'t miss out – act now to secure your discount!',
      buttonText: 'Limited time only - Get 70% OFF Now!>>>',
      buttonUrl: '#'
    },
    styles: {
      backgroundColor: '#fce4ec',
      padding: '20px',
      borderRadius: '8px',
      marginBottom: '10px',
      textAlign: 'center'
    }
  },
  [ELEMENT_TYPES.CUSTOM_LIST]: {
    type: ELEMENT_TYPES.CUSTOM_LIST,
    rows: [
      { icon: 'check', text: 'List item 1' },
      { icon: 'check', text: 'List item 2' },
      { icon: 'check', text: 'List item 3' },
    ],
    textStylePreset: 'paragraph1',
    styles: {
      backgroundColor: '#ffffff',
      color: '#101022',
      fontFamily: 'Inter, Arial, sans-serif',
      fontSize: '1.25rem',
      borderRadius: '12px',
      padding: '24px',
      margin: '0 0 8px 0',
    },
  },
  [ELEMENT_TYPES.IMAGE_OVERLAY]: {
    type: ELEMENT_TYPES.IMAGE_OVERLAY,
    imageSrc: 'https://via.placeholder.com/800x500?text=Background+Image',
    imagePosition: { x: 0, y: 0 },
    imageScale: 1,
    zones: [{ id: 'overlay-zone', elements: [], width: '100%', height: 'auto' }],
    styles: {
      position: 'relative',
      width: '100%',
      height: 400,
      marginBottom: '10px',
      borderRadius: '8px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      overflow: 'visible',
    },
    overlayStyles: {
      position: 'absolute',
      bottom: '20px',
      right: '20px',
      backgroundColor: '#ffffff',
      padding: '20px',
      borderRadius: '8px',
      boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
      width: 'auto',
      minWidth: '200px',
      maxWidth: '80%',
      zIndex: 100,
      display: 'flex',
      flexDirection: 'column',
      gap: '8px'
    },
  },
  [ELEMENT_TYPES.CUSTOM_LIST_TWO_LINE]: {
    type: ELEMENT_TYPES.CUSTOM_LIST_TWO_LINE,
    rows: [
      { icon: 'check', text1: 'Feature Title 1', text2: 'Detailed description of the first feature' },
      { icon: 'check', text1: 'Feature Title 2', text2: 'Detailed description of the second feature' },
      { icon: 'check', text1: 'Feature Title 3', text2: 'Detailed description of the third feature' },
    ],
    textStylePreset1: 'subheading1', // For first line (titles)
    textStylePreset2: 'paragraph1', // For second line (descriptions)
    styles: {
      backgroundColor: '#ffffff',
      color: '#101022',
      fontFamily: 'Inter, Arial, sans-serif',
      fontSize: '1.25rem',
      borderRadius: '12px',
      padding: '24px',
      margin: '0 0 8px 0',
    },
  },
  [ELEMENT_TYPES.FAQ_ACCORDION]: {
    type: ELEMENT_TYPES.FAQ_ACCORDION,
    title: 'MoonBrew FAQs',
    items: [
      { question: 'What are the benefits of MoonBrew?*', answer: 'MoonBrew offers a variety of benefits including ...' },
      { question: 'How might MoonBrew affect my sleep?', answer: 'MoonBrew is designed to support restful sleep by ...' },
      { question: 'Is there melatonin in MoonBrew?', answer: 'No, MoonBrew does not contain melatonin.' },
      { question: 'Is there caffeine in MoonBrew?', answer: 'No, MoonBrew is caffeine-free.' },
      { question: 'Is there sugar in MoonBrew?', answer: 'MoonBrew contains no added sugar.' },
      { question: 'How is MoonBrew made?', answer: 'MoonBrew is crafted using ...' },
      { question: 'Can I drink MoonBrew while pregnant?', answer: 'Please consult your healthcare provider before consuming MoonBrew while pregnant.' },
    ],
    iconType: 'plusMinus',
    iconColor: '#36C3D6',
    iconSize: 'large',
    showIcon: true,
    // New styling options
    textAlign: 'left',
    containerBackgroundColor: 'transparent',
    questionBackgroundColor: 'transparent',
    answerBackgroundColor: 'rgba(0, 0, 0, 0.02)',
    questionTextColor: '#4B329A',
    answerTextColor: '#4B329A',
    titleTextColor: 'primary',
    showDivider: true,
    dividerColor: '#C1A7F1',
    itemBorderRadius: '4px',
    itemSpacing: '12px',
    questionPadding: '16px',
    answerPadding: '16px',
    styles: { marginBottom: '10px' }
  },
  [ELEMENT_TYPES.COMPARISON_TABLE]: {
    type: ELEMENT_TYPES.COMPARISON_TABLE,
    title: 'Product Comparison',
    productA: 'AlphaCleanse',
    productB: 'Brand X',
    productAImage: '',
    productBImage: '',
    rows: [
      { feature: 'Nutrient Diversity', description: 'From 12 science-backed superfoods', productA: true, productB: false },
      { feature: 'Organic Ingredients', description: '100% all-natural & toxin free', productA: true, productB: false },
      { feature: 'Full Transparency', description: 'No hidden "proprietary blends"', productA: true, productB: false },
    ],
    titleStylePreset: 'compareTableTableTitle',
    productNameStylePreset: 'compareTableProdctName',
    featureTitleStylePreset: 'compareTableFeatureTitle',
    featureDescStylePreset: 'compareTableFeatureDescription',
    styles: { marginBottom: '10px' }
  },
  [ELEMENT_TYPES.TWO_COLUMN_COMPARISON]: {
    type: ELEMENT_TYPES.TWO_COLUMN_COMPARISON,
    leftColumnTitle: 'My Old Pillow',
    rightColumnTitle: 'My New Fluffco Pillow',
    leftColumnImage: '',
    rightColumnImage: '',
    leftItems: [
      'Was hard to find a comfortable sleeping position',
      'I constantly woke up with neck and shoulder pain',
      'I felt tired and groggy most mornings'
    ],
    rightItems: [
      "I've had the best sleep of my life in a long time",
      'I wake up every morning feeling refreshed and pain-free',
      'I fall asleep faster and stay asleep for longer'
    ],
    titleStylePreset: 'compareTableTwoColumnColumnTitle',
    itemStylePreset: 'compareTableTwoColumnItemTitle',
    styles: { marginBottom: '10px' }
  },
  [ELEMENT_TYPES.TIMELINE_LIST]: {
    type: ELEMENT_TYPES.TIMELINE_LIST,
    steps: [
      {
        stageLabel: 'STAGE 1',
        stageLabelColor: '#1976d2',
        title: 'Initial Setup',
        description: 'Begin the process with basic configuration and setup.',
        dotColor: '#1976d2',
      },
      {
        stageLabel: 'STAGE 2',
        stageLabelColor: '#1976d2',
        title: 'Core Processing',
        description: 'Execute the main functionality and process the data.',
        dotColor: '#1976d2',
      },
      {
        stageLabel: 'STAGE 3',
        stageLabelColor: '#1976d2',
        title: 'Final Results',
        description: 'Complete the process and deliver the final results.',
        dotColor: '#1976d2',
      },
    ],
    styles: {
      backgroundColor: '#fff',
      color: '#222',
      fontFamily: 'Inter, Arial, sans-serif',
      fontSize: '1.1rem',
      borderRadius: '12px',
      padding: '24px',
      margin: '0 0 16px 0',
    },
  },
  [ELEMENT_TYPES.PROCESS_STEPS]: {
    type: ELEMENT_TYPES.PROCESS_STEPS,
    steps: [
      {
        number: 1,
        title: 'Remove From Case',
        description: 'It requires zero preparation, visits to a specialist, or boiling and molding.',
        image: 'https://via.placeholder.com/150x150?text=Step+1',
        numberColor: '#1976d2',
        backgroundColor: '#f8f9fa',
      },
      {
        number: 2,
        title: 'Insert Product',
        description: 'Unlike alternatives that lock your jaw, the product allows you to move your mouth freely.',
        image: 'https://via.placeholder.com/150x150?text=Step+2',
        numberColor: '#1976d2',
        backgroundColor: '#f8f9fa',
      },
      {
        number: 3,
        title: 'Enjoy Results!',
        description: 'The product instantly widens your airway to stop tissue vibration - and with it, snoring!',
        image: 'https://via.placeholder.com/150x150?text=Step+3',
        numberColor: '#1976d2',
        backgroundColor: '#f8f9fa',
      },
    ],
    styles: {
      backgroundColor: '#fff',
      color: '#333',
      fontFamily: 'Inter, Arial, sans-serif',
      fontSize: '1rem',
      borderRadius: '12px',
      padding: '24px',
      margin: '0 0 16px 0',
    },
  },
  [ELEMENT_TYPES.TEXT_WITH_RIGHT_IMAGE]: {
    type: ELEMENT_TYPES.TEXT_WITH_RIGHT_IMAGE,
    content: {
      text: 'How might MoonBrew affect my sleep?',
      image: 'https://via.placeholder.com/200x150?text=Image'
    },
    styles: {
      backgroundColor: '#fff',
      color: '#333',
      fontFamily: 'Inter, Arial, sans-serif',
      fontSize: '1.1rem',
      borderRadius: '12px',
      padding: '20px',
      margin: '0 0 16px 0',
    },
  },
  [ELEMENT_TYPES.LEFT_IMAGE_TEXT]: {
    type: ELEMENT_TYPES.LEFT_IMAGE_TEXT,
    content: {
      text: 'Your text content goes here. This is flexible text that can be edited inline.',
      image: 'https://via.placeholder.com/150x150?text=Profile'
    },
    styles: {
      display: 'flex',
      alignItems: 'center',
      gap: '20px',
      marginBottom: '20px',
      flexWrap: 'wrap'
    },
    imageSize: 120,
    spacing: 20,
    imageAlignment: 'center',
    textStyles: {
      fontSize: '16px',
      color: '#333333',
      backgroundColor: 'transparent',
      fontWeight: 'normal',
      fontFamily: 'inherit',
      lineHeight: '1.6',
      textAlign: 'left',
      padding: '0px',
      borderRadius: '0px'
    }
  },
  [ELEMENT_TYPES.QUOTATION_BLOCK]: {
    type: ELEMENT_TYPES.QUOTATION_BLOCK,
    content: 'Korem ipsum <strong>dolor</strong> sit amet, consectetur fvfe adipiscing elit. <strong>Nunc vulputate libero etz df</strong> vvbbzj <strong>dffgnhncvh</strong> velit interdum, ac aliquet',
    styles: {
      backgroundColor: '#fce7f3',
      color: '#101022',
      borderRadius: '15px',
      padding: '24px 32px', // Simple padding like TEXT elements
      marginBottom: '20px',
      textAlign: 'left',
      position: 'relative',
      fontStyle: 'italic',
      fontSize: '18px',
      fontWeight: '400',
      lineHeight: '1.5',
      fontFamily: "'Inter', sans-serif"
    },
    textStylePreset: 'quotation1'
  },
  [ELEMENT_TYPES.STAR_RATING]: {
    type: ELEMENT_TYPES.STAR_RATING,
    rating: 5,
    maxStars: 5,
    styles: {
      color: '#ffc107',
      fontSize: '24px',
      marginBottom: '10px',
      textAlign: 'center',
      display: 'flex',
      justifyContent: 'center',
      gap: '4px'
    }
  },
  [ELEMENT_TYPES.STAR_RATING_TABLE]: {
    type: ELEMENT_TYPES.STAR_RATING_TABLE,
    title: 'Review Summary',
    rows: [
      { id: '1', label: 'Formula Potency', rating: 4.5, suffix: 'A+' },
      { id: '2', label: 'Ingredient Safety', rating: 4, suffix: 'A+' },
      { id: '3', label: 'Customer Service', rating: 5, suffix: 'A+' }
    ],
    maxStars: 5,
    showRowDividers: true,
    styles: {
      backgroundColor: '#ffffff',
      color: '#ffc107',
      fontSize: '22px',
      labelFontSize: '18px',
      gap: '4px',
      titleFontSize: '18px',
      titleColor: '#000000',
      marginBottom: '20px',
      padding: '24px',
      borderRadius: '12px',
      border: '1px solid #eeeeee'
    }
  },
};
